"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Tokenized = /** @class */ (function () {
    function Tokenized(initParts, initTokens) {
        this.parts = initParts;
        this.tokens = initTokens;
        this.decorations = {};
        this.values = {};
    }
    Tokenized.prototype.decorate = function (tokenKey, Decoration) {
        var _this = this;
        this.decorations['$' + tokenKey] = function () {
            return React.createElement(Decoration, { text: _this.tokens[tokenKey] });
        };
        return this;
    };
    Tokenized.prototype.setValue = function (tokenKey, tokenValue) {
        this.values['$' + tokenKey] = tokenValue;
        return this;
    };
    Tokenized.prototype.build = function () {
        var _this = this;
        return function () {
            return (React.createElement(React.Fragment, null, _this.parts.map(function (part) {
                if (part.startsWith('$')) {
                    var Part = _this.decorations[part];
                    return React.createElement(Part, { key: part });
                }
                else {
                    return part;
                }
            })));
        };
    };
    Tokenized.prototype.buildString = function () {
        var _this = this;
        return this.parts.map(function (part) {
            if (part.startsWith('$')) {
                return _this.values[part];
            }
            else {
                return part;
            }
        }).join('');
    };
    return Tokenized;
}());
exports.Tokenized = Tokenized;
function tokenize(message) {
    var parts = [];
    var tokens = {};
    var pattern = /([^{]*)({(\w+)\|([^}]+)})([^{]*)/g;
    var matches;
    // tslint:disable-next-line:no-conditional-assignment
    while (matches = pattern.exec(message)) {
        parts.push(matches[1]);
        if (matches.length > 2) {
            var token = {};
            var tokenKey = matches[3];
            token[tokenKey] = matches[4];
            parts.push('$' + tokenKey);
            tokens = __assign({}, tokens, token);
        }
        if (matches.length > 5) {
            parts.push(matches[5]);
        }
    }
    return new Tokenized(parts, tokens);
}
exports.tokenize = tokenize;
